export const trackEvent = (name, properties) => {
  if (window && window.umami) {
    window.umami.track(name, properties);
  }
}